import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import { authService } from "services/auth.service";

class AuthStore {
  user: any = null;
  token: string | null = localStorage.getItem("token");
  manuallyLoggedOut = false;
  loading: boolean = false;

  constructor() {
    makeAutoObservable(this);
    this.initialize();
  }

  private initialize() {
    const token = localStorage.getItem("token");
    if (token) {
      this.token = token;
      if (this.isTokenValid()) {
        this.fetchUser();
      } else {
        this.logout();
      }
    }
  }

  // login
  async login(email: string, password: string) {
    this.loading = true;
    try {
      const data = await authService.login(email, password);
      runInAction(() => {
        this.token = data?.token;
        this.user = data?.user;
      });
      localStorage.setItem("token", data?.token);
      toast.success(`Bienvenue, ${data?.user?.fullName}`);
    } catch (error: any) {
      throw error;
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  // update user profile
  async updateProfile(data: FormData) {
    this.loading = true;
    try {
      if (!this.user?.id) throw new Error("Utilisateur non chargé");
      const updatedUser = await authService.updateProfile(this.user.id, data);
      runInAction(() => {
        this.user = updatedUser;
      });
      toast.success("Profil mis à jour avec succès");
    } catch (error: any) {
      throw error;
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  // fetch user
  async fetchUser() {
    this.loading = true;
    try {
      if (!this.token || !this.isTokenValid()) return;
      const userData = await authService.getCurrentUser();
      runInAction(() => {
        this.user = userData;
      });
    } catch (error) {
      // console.error("Erreur lors du chargement des infos utilisateur :", error);
      this.logout();
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  logout(showMessage = false) {
    this.token = null;
    this.user = null;
    this.manuallyLoggedOut = true;
    localStorage.removeItem("token");
    if (showMessage) {
      toast.info("Déconnexion réussie");
    }
  }

  resetLogoutFlag() {
    this.manuallyLoggedOut = false;
  }

  isAuthenticated() {
    return !!this.token;
  }

  getRole() {
    return this.user?.role;
  }

  hasRole(role: string) {
    return this.user?.role === role;
  }

  isTokenValid() {
    if (!this.token) return false;
    try {
      const payload = JSON.parse(atob(this.token.split(".")[1]));
      return payload.exp > Math.floor(Date.now() / 1000);
    } catch {
      return false;
    }
  }
}

const authStore = new AuthStore();
export default authStore;
